export default {
  pageDecorate: {
    ariaEdit: 'Edit',
    graphicNavCountSuffix: 'navigation items',
    lbl_02ddb4554d: 'Recipient:',
    lbl_040a5c16c7: 'Auto-Recharge Deduction Ratio:',
    lbl_04a534f3a5: 'Taxpayer ID:',
    lbl_056f2d7df6: 'Navigation',
    lbl_08363955f4: 'Back Button',
    lbl_091fc2d76d: 'Phone:',
    lbl_0a6bfb272d: 'Tag Color',
    lbl_0bc5794fd2: 'Ticket Title',
    lbl_0bc8ac93ec: 'Multiple Schools:',
    lbl_0bf6cc005b: 'Learning Center Tag:',
    lbl_0cab5bf687: 'Device Information:',
    lbl_0cf2fe2914: 'Guide Line Color',
    lbl_0e1bf7ba51: 'Ticket Creator',
    lbl_0fad5de61c: 'Text Height',
    lbl_102c00ea4d: 'Contact Email:',
    lbl_15d02f961d: 'Page Margin',
    lbl_16090bee10: 'Invoice Title:',
    lbl_1745f209df: 'Product Badge',
    lbl_18200de7cd: 'Discount Information',
    lbl_182e9afbb9: 'Video Link',
    lbl_19983fa06e: 'SN Code:',
    lbl_1a10cd6599: 'Description Content',
    lbl_1a3adde2f2: 'Invoice Tax ID:',
    lbl_1ab25b87cb: 'Headquarters Leads Delivery Plan:',
    lbl_1c76748802: 'Font Weight',
    lbl_1d720cd466: 'Bank Account Number:',
    lbl_1ee75f16f0: 'Elementary Small Class Pricing:',
    lbl_207424204a: 'Maximum Capacity:',
    lbl_21b48fa906: 'Contract Manager:',
    lbl_21bebbe5cd: 'Purchase Order Number:',
    lbl_22b03c024d: 'QR Code',
    lbl_255f442c4a: 'Custom Color',
    lbl_257ccf2b58: 'Description Weight',
    lbl_25aa43b508: 'Middle School Chemistry Curriculum Version:',
    lbl_281e8c354f: 'Contact Information:',
    lbl_282f51d840: 'Pricing Plan:',
    lbl_29771b8f9e: 'Number of Classes:',
    lbl_29efe66996: 'Master Franchisee ID:',
    lbl_2c31f81f00: 'Rent / Year:',
    lbl_30bf42e112: 'Courier Company:',
    lbl_30d2f82d09: 'IP Address:',
    lbl_32c65d8d74: 'Title',
    lbl_32dab3b09c: 'Autoplay',
    lbl_344f459e96: 'Legal Name:',
    lbl_366f6dd487: 'Card Style',
    lbl_371a3b9108: 'Shipping Address:',
    lbl_3a737c66f0: 'Password:',
    lbl_3a8647306e: 'Title Position',
    lbl_3b33ac4d19: 'Text Color',
    lbl_3bdd08adab: 'Description',
    lbl_3c6b686d4d: 'Elementary Math Curriculum Version:',
    lbl_3d4ac6ea3b: 'Note Tag',
    lbl_3d96b8f799: 'Single-Screen Display',
    lbl_3e07996cd2: 'Location:',
    lbl_3f5e9a64a6: 'School Enrollment:',
    lbl_3ffa035102: 'Verification Code:',
    lbl_402b79ad66: 'Scan',
    lbl_405ac6e226: 'Before Change',
    lbl_409120b562: 'Profile',
    lbl_41a9331ca3: 'Product Style',
    lbl_41fe816cd3: 'Mobile Number:',
    lbl_42b6206979: 'Entry Image',
    lbl_42bda62972: 'Business License Attachment:',
    lbl_43ab9af06e: 'Title Content',
    lbl_4573a75803: 'Background Color',
    lbl_45bc0c40d4: 'Enable Double Order:',
    lbl_4621eae280: 'High School Small Class Pricing:',
    lbl_484973fb2b: 'Blank Space Height',
    lbl_49dbfdd7e4: 'Payment Reference Number:',
    lbl_4a16588c34: 'Recipient Contact Information:',
    lbl_4a1e658c10: 'Border Color',
    lbl_4c7c3fffe6: 'Camera:',
    lbl_4d7a2304e8: 'Registration Information Settings (Multiple Choice):',
    lbl_518bbd63ec: 'Master Franchisee Tag:',
    lbl_5317cd7fb9: 'Unselected Color',
    lbl_5721abf1f2: 'Recipient:',
    lbl_575bba6bd2: 'Rent / Month:',
    lbl_5831dd1cd2: 'Admissions Email:',
    lbl_5a0fe6ca08: 'Attachment:',
    lbl_5a16b5f797: 'Setup Fee:',
    lbl_5a766e6b9f: 'File Purpose:',
    lbl_5a7f7cff87: 'Number of Stores Allowed:',
    lbl_5aa955d842: 'Learning Center ID:',
    lbl_5d765cbf1b: 'Signatory Address:',
    lbl_5e59e7365a: 'Batch Number:',
    lbl_5f4907d97c: 'Invoice Title:',
    lbl_617db300df: 'Activity Owner:',
    lbl_6245552bbd: 'Description Color',
    lbl_64b2cc3410: 'Recharge Amount:',
    lbl_65ca794f12: 'High School Chinese Curriculum Version:',
    lbl_6781e352d0: 'Middle School English Curriculum Version:',
    lbl_67acecd161: 'ID Number:',
    lbl_68cfd3dffb: 'Learning Center Address:',
    lbl_6b36c6f7ec: 'Color',
    lbl_6b3acbf150: 'Support Staff:',
    lbl_6cca2719c8: 'Collaboration Information',
    lbl_6cf50c210b: 'Writing Tablet:',
    lbl_6d45fffeee: 'Horizontal Margin',
    lbl_6fc0e71744: 'School State/City/District:',
    lbl_7035c62fb0: 'Account',
    lbl_706d07c4cc: 'Authorized Representative Name:',
    lbl_70e84c0387: 'Container Height',
    lbl_7192bf129c: 'Verification Code:',
    lbl_7245f2c049: 'Product Spacing',
    lbl_742e0c20ea: 'High School Physics Curriculum Version:',
    lbl_75c1f8c8b6: 'Detailed Address:',
    lbl_765de7391a: ' Curriculum Version:',
    lbl_7664627e74: 'Title Weight',
    lbl_76a3a16ff1: 'Channel:',
    lbl_776b1ca3c2: 'Destination Page',
    lbl_778476b73d: 'Total Payment:',
    lbl_787b5677e3: 'Gender',
    lbl_7acf573116: 'Elementary Small Class Original Price:',
    lbl_7d76f1c6fb: 'Highlight Position',
    lbl_7e08855457: 'Recipient Mobile Number:',
    lbl_7eacb4d906: 'Legal Name',
    lbl_7ec907e705: 'Text Color',
    lbl_7f1bb5b5c3: 'Middle School Large Class Pricing:',
    lbl_82e19e683d: 'High School Small Class Original Price:',
    lbl_856474a71d: 'Bank Name:',
    lbl_85adfe7fbd: 'Manufacturer:',
    lbl_85f581a05d: 'Elementary Large Class Pricing:',
    lbl_8627bfd5e5: 'Ticket Details',
    lbl_8896d6e909: 'After Change',
    lbl_898a701cac: 'Number of Classrooms:',
    lbl_8a01952db2: 'Pricing Factor:',
    lbl_8d2317049c: 'Default Color',
    lbl_8f7c576579: 'Region Information',
    lbl_8fd3f6dc0b: 'Courier Mobile Number:',
    lbl_90b8640967: 'Business License Number:',
    lbl_90ef7c485b: 'View More',
    lbl_915a911788: 'Learning Center Type:',
    lbl_91fe07e2e3: 'Login Account:',
    lbl_9233da5b5a: 'Merchant ID:',
    lbl_9384861fd6: 'Package Fee:',
    lbl_93ab99d761: 'Font Size',
    lbl_93bd60528b: 'Text Position',
    lbl_9440e4bdd0: 'Purchase Button',
    lbl_945e635a60: 'Description Size',
    lbl_94a34827d2: 'Material Information',
    lbl_94e391ba46: 'Title Color',
    lbl_986d366b99: 'Contact Name',
    lbl_98749f006c: 'Grade:',
    lbl_991e5e07de: 'Daily Claim Limit:',
    lbl_994b3edae7: 'Title Font Size',
    lbl_99fa0ccf6f: 'Middle School Small Class Original Price:',
    lbl_99fb57a4f7: 'Telemarketing Staff:',
    lbl_9aac36099a: 'Container Style',
    lbl_9c3929baa4: 'Account:',
    lbl_9c81917214: 'Subject:',
    lbl_9cf4c6ad6e: 'Product Price',
    lbl_9ff563bded: 'Initial Account:',
    lbl_a0a0862ca5: 'Contract Number:',
    lbl_a0a837f287: 'Display Position',
    lbl_a0f441a6bd: 'Middle School Math Curriculum Version:',
    lbl_a321a3cff2: 'Current Balance:',
    lbl_a34ccadd92: 'Boarding Status:',
    lbl_a4091ad20a: 'School Overview:',
    lbl_a5791b7ddc: 'Bank Name:',
    lbl_a594615071: 'Learning Center Rating:',
    lbl_a5c887f3fe: 'Admissions Phone:',
    lbl_a5f3056296: 'High School Math Curriculum Version:',
    lbl_a641cfff1d: 'Image Margin',
    lbl_a6695e3433: 'Contact Email',
    lbl_a789515f85: 'High School Chemistry Curriculum Version:',
    lbl_a810520460: 'Password',
    lbl_a96b9768a1: 'Middle School Small Class Pricing:',
    lbl_abf8f48093: 'Page Description',
    lbl_ac188aeae0: 'Official Account ID',
    lbl_ac8cfdfb57: 'Selected Color',
    lbl_ad22c45df8: 'Computer:',
    lbl_adac24db4a: 'Select Template',
    lbl_adbf7600a3: 'Image Spacing',
    lbl_af315fecb2: 'High School Large Class Pricing:',
    lbl_af3abf07ec: 'Contract Manager:',
    lbl_b0d7ee1533: 'School Information',
    lbl_b1aa8e7d07: 'Tmall Store ID:',
    lbl_b4491c5317: 'New Mobile Number:',
    lbl_b44ba0ddca: 'Contract Attachment',
    lbl_b530b8b44f: 'Headquarters Online Payment:',
    lbl_b5894313c2: 'Contact Information',
    lbl_b678141cb4: 'Merchant:',
    lbl_bcf71e7c75: 'Original Mobile Number:',
    lbl_c182ad6b97: 'Left Icon',
    lbl_c1df04eec5: 'Height',
    lbl_c6b4d76e64: 'Phone:',
    lbl_c9a6ee90f5: 'Attachment',
    lbl_c9b55e60bf: 'Left Title',
    lbl_cc19463999: 'Signing Manager:',
    lbl_cd6c4172d8: 'Middle School Chinese Curriculum Version:',
    lbl_cf4424d749: 'High School English Curriculum Version:',
    lbl_d2a877b42b: 'Payment Method:',
    lbl_d4d2a66820: 'Position',
    lbl_d53bad00d1: 'Right Content',
    lbl_d748497cb5: 'Background Image',
    lbl_d7a47ec7e8: 'Account:',
    lbl_db261a0107: 'Elementary Chinese Curriculum Version:',
    lbl_dcc86dbfdf: 'Subscription Duration (Months):',
    lbl_ddbe1d7bf0: 'Learning Center Area:',
    lbl_dec2eb7145: 'Link URL',
    lbl_df3833270b: 'Address:',
    lbl_e20a8291f1: 'Amount Due:',
    lbl_e243f649cb: 'Contact Information:',
    lbl_e245764011: 'Image Corner Radius',
    lbl_e2e09fb16a: 'Outer Border',
    lbl_e512d692b9: 'Shipping Address:',
    lbl_e55a8735e9: 'Contract Information',
    lbl_e853cf8ef7: 'Registration Success Notification:',
    lbl_e8835aceaa: 'Tracking Number:',
    lbl_ea1e0dbccc: 'Image Style',
    lbl_eab3ad101b: 'Change Log',
    lbl_eeb70ad310: 'View Count',
    lbl_f0b8bdd4aa: 'Learning Stage:',
    lbl_f14633eb92: 'Contract Entity:',
    lbl_f5a1e7a18a: 'Cover Link',
    lbl_f757e0bc38: 'Stage/Grade:',
    lbl_f82dbb8a4a: 'Daily Phone Number View Limit:',
    lbl_f8867b393b: 'Bottom Divider',
    lbl_fa33129586: 'Initial Withdrawal Limit:',
    lbl_fa86f1a57d: 'Announcement',
    lbl_fa895c4eb5: 'Elementary English Curriculum Version:',
    lbl_fd67478677: 'ID Clock-in Device:',
    lbl_fd71364919: 'Items per Row',
    lbl_fd98c9567f: 'Select Style',
    lbl_fe411c66be: 'Middle School Physics Curriculum Version:',
    lbl_fea3394875: 'Official Account Image',
    lbl_febbf6c0c3: 'Like Count',
    workOrderSubmitAt: 'Ticket Submission Time',
  },
}
